// extracted by mini-css-extract-plugin
module.exports = {"list":"Menu_list__1d9AJ","item":"Menu_item__3wuFE","link":"Menu_link__xyJ8x","active":"Menu_active__bj2w7","icon":"Menu_icon__2hxJQ"};